/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Tags_Meta_Socialtitle1Inputs */

const id_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const ms_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const da_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const de_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const en_us2_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const es_es2_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const es_mx2_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const fil_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const fr_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const it_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const hu_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const nl_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const no_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const pl_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const pt_br2_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const pt_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const ro_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const fi_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const sv_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const vi_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const tr_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const cs_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const bg_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const ru_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} — egdata.app`)
};

const uk_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const ar_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const hi_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const th_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const ja_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const zh_cn2_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const zh_hant1_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

const ko_tags_meta_socialtitle1 = /** @type {(inputs: Tags_Meta_Socialtitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} - egdata.app`)
};

/**
* | output |
* | --- |
* | "{title} - egdata.app" |
*
* @param {Tags_Meta_Socialtitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_meta_socialtitle1 = /** @type {((inputs: Tags_Meta_Socialtitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Meta_Socialtitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_meta_socialtitle1(inputs)
	if (locale === "ms") return ms_tags_meta_socialtitle1(inputs)
	if (locale === "da") return da_tags_meta_socialtitle1(inputs)
	if (locale === "de") return de_tags_meta_socialtitle1(inputs)
	if (locale === "en-US") return en_us2_tags_meta_socialtitle1(inputs)
	if (locale === "es-ES") return es_es2_tags_meta_socialtitle1(inputs)
	if (locale === "es-MX") return es_mx2_tags_meta_socialtitle1(inputs)
	if (locale === "fil") return fil_tags_meta_socialtitle1(inputs)
	if (locale === "fr") return fr_tags_meta_socialtitle1(inputs)
	if (locale === "it") return it_tags_meta_socialtitle1(inputs)
	if (locale === "hu") return hu_tags_meta_socialtitle1(inputs)
	if (locale === "nl") return nl_tags_meta_socialtitle1(inputs)
	if (locale === "no") return no_tags_meta_socialtitle1(inputs)
	if (locale === "pl") return pl_tags_meta_socialtitle1(inputs)
	if (locale === "pt-BR") return pt_br2_tags_meta_socialtitle1(inputs)
	if (locale === "pt") return pt_tags_meta_socialtitle1(inputs)
	if (locale === "ro") return ro_tags_meta_socialtitle1(inputs)
	if (locale === "fi") return fi_tags_meta_socialtitle1(inputs)
	if (locale === "sv") return sv_tags_meta_socialtitle1(inputs)
	if (locale === "vi") return vi_tags_meta_socialtitle1(inputs)
	if (locale === "tr") return tr_tags_meta_socialtitle1(inputs)
	if (locale === "cs") return cs_tags_meta_socialtitle1(inputs)
	if (locale === "bg") return bg_tags_meta_socialtitle1(inputs)
	if (locale === "ru") return ru_tags_meta_socialtitle1(inputs)
	if (locale === "uk") return uk_tags_meta_socialtitle1(inputs)
	if (locale === "ar") return ar_tags_meta_socialtitle1(inputs)
	if (locale === "hi") return hi_tags_meta_socialtitle1(inputs)
	if (locale === "th") return th_tags_meta_socialtitle1(inputs)
	if (locale === "ja") return ja_tags_meta_socialtitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_meta_socialtitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_meta_socialtitle1(inputs)
	return ko_tags_meta_socialtitle1(inputs)
});
export { tags_meta_socialtitle1 as "tags.meta.socialTitle" }